// extracted by css-extract-rspack-plugin
var _1 = "bullet__W43ed";
var _2 = "container__rXzqb";
var _3 = "container--top-margin__x7eT_";
var _4 = "lightbulb__yAixV";
var _5 = "text__HdcZc";
export { _1 as "bullet", _2 as "container", _3 as "container--top-margin", _4 as "lightbulb", _5 as "text" }
export default { "bullet": _1, "container": _2, "container--top-margin": _3, "lightbulb": _4, "text": _5 }
